import PadLeftWithLeadingZeros from "./PadLeftWithLeadingZeros";

/**
 * Conver 12hrs to 24hrs format
 * @param {any} time12h 12hrs format e.g '12:00 AM'
 */
const ConvertTime12to24 = function (time12h) {
    // var [cTime, cModifier] = time12h.split(' ');
    // var [cHours, cMinutes] = cTime.split(':');
    const time12hSplitted = time12h.split(' ');
    const cTime = time12hSplitted[0];
    const cModifier = time12hSplitted[1];
    const cTimeSplitted = cTime.split(':');
    let cHours = cTimeSplitted[0];
    let cMinutes = cTimeSplitted[1];
    if (cHours === '12') {
        cHours = '00';
    }
    if (cModifier === 'PM') {
        cHours = parseInt(cHours, 10) + 12;
    }
    cHours = PadLeftWithLeadingZeros(parseInt(cHours), 2);
    cMinutes = PadLeftWithLeadingZeros(parseInt(cMinutes), 2);
    return `${cHours}:${cMinutes}`;
};
export default ConvertTime12to24;
